// test198
(198 && 0);
